import { type FilterOptionSource, filterUnitFor } from 'noddi-ui-web';
import { orderFilterUnit } from './orderFilterUnit';

/** URL-only picks: services and products both narrow the orders endpoint's one `salesItemIds` param. */
const salesItemPicker = filterUnitFor<{
  serviceIds?: number[];
  excludedServiceIds?: number[];
  productIds?: number[];
  excludedProductIds?: number[];
}>();

/** Services and products: two pickers sent as one `salesItemIds` param (and its exclusion). */
export const orderSalesItemsFilter = ({
  services,
  products
}: {
  services: FilterOptionSource<number>;
  products: FilterOptionSource<number>;
}) =>
  orderFilterUnit.map(
    [
      salesItemPicker.multiSelect('serviceIds', {
        title: 'Services',
        description: 'Filter by services',
        source: services,
        defaultVisibleOptions: 3,
        exclude: true
      }),
      salesItemPicker.multiSelect('productIds', {
        title: 'Products',
        description: 'Filter by products',
        source: products,
        defaultVisibleOptions: 3,
        exclude: true
      })
    ],
    (params) => ({
      salesItemIds: [...(params.serviceIds ?? []), ...(params.productIds ?? [])],
      excludedSalesItemIds: [...(params.excludedServiceIds ?? []), ...(params.excludedProductIds ?? [])]
    })
  );
